import { Accordion } from '../../../../../common/Accordion';
import { Icon } from '../../../../../common/Icon';
import { GroupedAdhocData } from '../../../hooks/useSprintTimeline';
import { getTotalGroupedItems } from '../helpers';

import { TimelineItem } from './TimelineItem';

export function AdhocAccordion({
  groupedAdhocs,
}: {
  groupedAdhocs: GroupedAdhocData;
}): JSX.Element {
  const hasAdhocs = Object.keys(groupedAdhocs || {}).length > 0;

  return (
    <Accordion
      title={
        <div className="flex justify-between w-full items-center">
          <div className="flex items-center gap-2">
            <Icon name="timer" className="text-[#FA8C16]" />
            Adhoc Tasks ({getTotalGroupedItems(groupedAdhocs)})
          </div>
        </div>
      }
    >
      {!hasAdhocs ? (
        <div className="text-gray-500 text-sm py-4 text-center">
          No adhoc tasks recorded for this period
        </div>
      ) : (
        Object.keys(groupedAdhocs || {})
          .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
          .map((dateKey, idx, arr) => {
            const adhocsForDate = groupedAdhocs[dateKey];
            if (!adhocsForDate) return null;
            return (
              <TimelineItem
                key={dateKey}
                date={dateKey}
                showLine={idx < arr.length - 1}
              >
                {adhocsForDate.map((adhoc) => (
                  <div
                    key={`${adhoc.id}-${adhoc.title}`}
                    className="ml-6 mt-2 bg-white border border-gray-200 rounded-lg p-4 text-sm text-gray-700 shadow-sm"
                  >
                    <div className="font-semibold">{adhoc.title}</div>
                    <div className="mt-2">{adhoc.description}</div>
                  </div>
                ))}
              </TimelineItem>
            );
          })
      )}
    </Accordion>
  );
}
